const RiderCategoryIndex = () => import('./views/RiderCategoryIndex.vue')
const RiderCategoryCreate = () => import('./views/RiderCategoryCreate.vue')
const RiderCategoryEdit = () => import('./views/RiderCategoryEdit.vue')

export default [
  {
    path: 'riders/categories',
    name: 'riders.categories.index',
    component: RiderCategoryIndex
  },
  {
    path: 'riders/categories/create',
    name: 'riders.categories.create',
    component: RiderCategoryCreate
  },
  {
    path: 'riders/categories/:categoryId(\\d+)',
    name: 'riders.categories.edit',
    component: RiderCategoryEdit
  }
]
